import { useModal } from '@shared/model/useModal';

export const useAddReviewModal = () => useModal('add-review')